// AUTO-GENERATED by scripts/compile-map-previews.ts — do not edit by hand
/* eslint-disable quotes -- generator emits JSON string literals */

/** A generated quest-guidance map preview: public/map-previews/<mapId>.svg, world-space viewBox. */
export interface MapPreviewInfo {
  width: number;
  height: number;
  /** The level's display name. */
  name: string;
}

export const MAP_PREVIEWS: Record<string, MapPreviewInfo> = {
  "abandoned_camp": { width: 8960, height: 2048, name: "Abandoned Camp" },
  "amber_grove": { width: 3200, height: 1600, name: "Amber Grove" },
  "ancient_temple": { width: 3400, height: 2000, name: "Ancient Temple" },
  "bloodmoon_reach": { width: 3200, height: 1600, name: "Bloodmoon Reach" },
  "brackenmoor": { width: 15000, height: 1450, name: "Brackenmoor" },
  "coil_undercroft": { width: 2400, height: 1600, name: "The Coil Undercroft" },
  "crystal_caverns": { width: 3600, height: 2000, name: "Crystal Caverns" },
  "dark_forest": { width: 3200, height: 1600, name: "Dark Forest" },
  "deep_woods": { width: 9216, height: 2048, name: "Deep Woods" },
  "duskfall_vale": { width: 3200, height: 1600, name: "Duskfall Vale" },
  "first_field": { width: 15000, height: 1800, name: "The First Field" },
  "frostspire_peaks": { width: 3200, height: 1600, name: "Frostspire Peaks" },
  "frozen_lake": { width: 2800, height: 1400, name: "Frozen Lake" },
  "glowspore_grotto": { width: 3200, height: 1600, name: "Glowspore Grotto" },
  "goldengrass_savanna": { width: 3200, height: 1600, name: "Goldengrass Savanna" },
  "moonfall_hollow": { width: 10000, height: 2000, name: "Moonfall Hollow" },
  "moonfen_pasture": { width: 10000, height: 2200, name: "Moonfen Pasture" },
  "murkwater_swamp": { width: 3200, height: 1600, name: "Murkwater Swamp" },
  "old_grove": { width: 9216, height: 2048, name: "Old Grove" },
  "scorched_dunes": { width: 3200, height: 1600, name: "Scorched Dunes" },
  "smoldering_wastes": { width: 3200, height: 1600, name: "Smoldering Wastes" },
  "stormbreak_cliffs": { width: 3200, height: 1600, name: "Stormbreak Cliffs" },
  "sunken_ruins": { width: 3200, height: 1800, name: "Sunken Ruins" },
  "sunkissed_shore": { width: 3200, height: 1600, name: "Sunkissed Shore" },
  "sunless_deep": { width: 3200, height: 1600, name: "Sunless Deep" },
  "tidewend": { width: 5000, height: 1400, name: "Tidewend Harbor" },
  "tidewend_outskirts": { width: 15600, height: 2000, name: "Tidewend Outskirts" },
  "verdant_canopy": { width: 3200, height: 1600, name: "Verdant Canopy" },
  "volcano_summit": { width: 3000, height: 1800, name: "Volcano Summit" },
  "wickhaven": { width: 2560, height: 1200, name: "Wickhaven" },
  "windswept_moor": { width: 3200, height: 1600, name: "Windswept Moor" },
};

export function mapPreviewUrl(mapId: string): string {
  return `/map-previews/${mapId}.svg`;
}
